import React from 'react'
import {Text} from './HomePageElements'

const HomePage = () => {
    return (
        <>
            <Text>Strona została stworzona w ramach realizacji pokazu na nocy Biologów 2026.</Text>
        </>
    )
}

export default HomePage
